import React, { Component } from "react";
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import NovedadesHelper from '../../../../../Common/Helpers/NovedadesHelper';

class CuartaLineaTarjeta extends Component {
    constructor(props) {
        super(props)

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(2, this.props.codigoNovedad, event.target.value, event.target.id);
    }
    /**
     * 
     */
    render() {
        const { props } = this;
        const { data, tarjeta } = props;
        let componente = null;

        let cuartaLineaTarjetaNovedad = NovedadesHelper.InputConNovedadPorCampos(this.props.codigoNovedad,
            tarjeta.CuartaLinea,
            data.novedadesTarjetaDatos,
            data.esNovedadEditada,
            [{ Clave: "TarjetaCreditoId", Valor: tarjeta.TarjetaCreditoId }]);

        const campoEditPanel = <input className="form-control" id={tarjeta.TarjetaCreditoId}
            value={cuartaLineaTarjetaNovedad.descripcion} onChange={this.changeInput} />;

        if (cuartaLineaTarjetaNovedad.novedadInput) {
            if (cuartaLineaTarjetaNovedad.novedadInput.ValorAnterior == "") {
                cuartaLineaTarjetaNovedad.novedadInput.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        return <div className="col-xs-12">
            <GenericEditPanel
                componente={campoEditPanel}
                novedad={cuartaLineaTarjetaNovedad.novedadInput}
                permisoUsuario={data.funcionesDelUsuario}
                seEstaEditando={data.seEstaEditando}
                textPanel={cuartaLineaTarjetaNovedad.descripcion || "Sin especificar"}
                title="Denominación 4ª línea (opcional)"
                value={cuartaLineaTarjetaNovedad.descripcion || "Sin especificar"}

                aceptChanges={(value) => this.props.guardarNovedad(value, null, tarjeta.TarjetaCreditoId)}
                confirmarNovedad={() => this.actualizarNovedadEstado(cuartaLineaTarjetaNovedad.novedadInput, 2, tarjeta.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(cuartaLineaTarjetaNovedad.novedadInput, 3, tarjeta.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        </div>
    }
}

export default CuartaLineaTarjeta;